module.exports = __webpack_public_path__ + "img/logo.43d4a415.svg";